<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          品目
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <v-row>
      <v-col class="text-right">
        <v-btn
          color="info"
          @click="addButtonClickEvent"
        >
          追加する
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-data-table
            :headers="tableHeaders"
            :items="items"
            disable-sort
            hide-default-footer
          >
            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | unix_datetime_format }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ item.updated_at | unix_datetime_format }}
            </template>
            <template v-slot:[`item.editable`]="{ item }">
              <v-btn
                v-if="$vuetify.breakpoint.mdAndUp"
                color="cyan darken-2"
                icon
                @click="editButtonClickEvent(item)"
              >
                <v-icon>mdi-note-edit</v-icon>
              </v-btn>
              <v-btn
                v-else
                text
                color="cyan"
                @click="editButtonClickEvent(item)"
              >
                編集する
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row dense>
      <v-col>
        <v-pagination
          v-model="current_page"
          :length="10"
          circle
          :total-visible="5"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
  </div>
</template>

<script>
export default {
  name: 'AdminMasterItemIndex',
  components: {},
  mixins: [],
  data () {
    return {
      current_page: 1,
      tableHeaders:[
        { value: 'code', text: 'コード' },
        { value: 'name', text: '廃棄物の種類' },
        { value: 'hierarchy', text: '分類' },
        { value: 'created_at', text: 'データ作成日時' },
        { value: 'updated_at', text: 'データ更新日時' },
        { value: 'editable', text: '', align: 'end' },
      ],
      items: [
        {
          id:1,
          name: '燃え殻',
          code: '0100000',
          hierarchy: null,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 2,
          name: '焼却灰',
          code: '0110000',
          hierarchy: '燃え殻',
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 3,
          name: '石炭灰',
          code: '0111000',
          hierarchy: '燃え殻/焼却灰',
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 4,
          name: '廃棄物の焼却灰',
          code: '0112000',
          hierarchy: '燃え殻/焼却灰',
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 5,
          name: '廃カーボン・活性炭',
          code: '0120000',
          hierarchy: '燃え殻',
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 6,
          name: '汚泥（泥状のもの）',
          code: '0200000',
          hierarchy: null,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 7,
          name: '有機性汚泥',
          code: '0210000',
          hierarchy: '汚泥（泥状のもの）',
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 8,
          name: '下水汚泥',
          code: '0211000',
          hierarchy: '汚泥（泥状のもの）/有機性汚泥',
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 9,
          name: '無機性汚泥',
          code: '0220000',
          hierarchy: '汚泥（泥状のもの）',
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 10,
          name: '建設汚泥（残土を除く）',
          code: '0221000',
          hierarchy: '汚泥（泥状のもの）/無機性汚泥',
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 11,
          name: '上水汚泥',
          code: '0222000',
          hierarchy: '汚泥（泥状のもの）/無機性汚泥',
          created_at: 1633314402,
          updated_at: 1633314402,
        },
      ],
    }
  },
  created() {
  },
  methods: {
    addButtonClickEvent () {
      this.$router.push({name: 'AdminMasterItemNew'})
    },
    editButtonClickEvent (item) {
      this.$router.push({name: 'AdminMasterItemEdit', params: {id: item.id}})
    },
  }
}
</script>

<style scoped>

</style>
